import { Reveal, SectionHead } from "./Reveal";
import { PROCESS_STEPS } from "@/data/content";

const Process = () => (
    <section id="process" className="py-24 sm:py-32 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHead
                eyebrow="How We Work"
                title="Our Process"
                sub="A five-step execution model that keeps every obligation visible and every deadline met."
            />
            <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-white/10 border border-white/10" data-testid="process-grid">
                {PROCESS_STEPS.map((p, i) => (
                    <Reveal key={p.num} delay={i * 0.08} className="bg-[#0A1128]">
                        <div className="h-full p-7 hover:bg-[#101D3F] transition-colors duration-300">
                            <span className="font-display text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-b from-sky-400 to-blue-700">
                                {p.num}
                            </span>
                            <h3 className="mt-5 font-heading text-base font-semibold text-white">{p.title}</h3>
                            <p className="mt-2 text-sm text-slate-400 leading-relaxed">{p.desc}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Process;
